/* if adding a new flag, update use-record-all-flags.ts */

"use client";

import { usePostHogFlag } from "../use-posthog-flag";

export function useMultiSignerEnabled() {
  return usePostHogFlag("enable_embedded_wallet_multi_signer");
}
